import { useEffect, useState } from 'react';
import { getStoredCustomerAuthToken } from './auth/customerAuthToken';
import { fetchStoresForStaffReserve } from './reservation/by-staff/fetchStoresForStaffReserve';
import { fetchStaffsForStaffReserve } from './reservation/by-staff/fetchStaffsForStaffReserve';
import { getNewStaffIds, getStaffUpdatesCustomerId } from './staffUpdates';
import { pickPreferredStore } from '../pages/Reserve/homeShared';

export const useNewStaff = (storeId: number | null): boolean => {
  const [hasNewStaff, setHasNewStaff] = useState(false);

  useEffect(() => {
    let active = true;
    let loading = false;
    const token = getStoredCustomerAuthToken();
    const customerId = getStaffUpdatesCustomerId();
    setHasNewStaff(false);
    if (!token || customerId === null) return;

    const refresh = async () => {
      if (loading || document.visibilityState !== 'visible') return;
      loading = true;
      try {
        const stores = await fetchStoresForStaffReserve();
        const store = pickPreferredStore(stores, storeId);
        if (!store) {
          if (active) setHasNewStaff(false);
          return;
        }
        const staffs = await fetchStaffsForStaffReserve(store.id);
        if (!active || token !== getStoredCustomerAuthToken()
          || customerId !== getStaffUpdatesCustomerId()) return;
        setHasNewStaff(getNewStaffIds(customerId, store.id, staffs.map((staff) => staff.id)).length > 0);
      } catch (error) {
        console.error('Failed to check staff updates:', error);
      } finally {
        loading = false;
      }
    };

    const onForeground = () => { void refresh(); };
    void refresh();
    window.addEventListener('focus', onForeground);
    document.addEventListener('visibilitychange', onForeground);
    const timer = window.setInterval(onForeground, 60_000);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener('focus', onForeground);
      document.removeEventListener('visibilitychange', onForeground);
    };
  }, [storeId]);

  return hasNewStaff;
};
